  <div class="action-panel-main" *ngIf="getLngDatalist?.length">
    <snl-action-panel class="pt-24">
      <div left-side class="CommonFiltersPanel df-c">
        <div class="ResetFiltersTxt body-b fw-700 df-c justify-content-start col-gap-16">
          
          <span class="color__primary section-title" >Filter(s)</span>
          <a href="javascript:void(0);" [ngClass]="{'active': resetActivate() == true}"
            class="ResetAllTxt resetAllFlTxt section-title" (click)="resetAll()">Reset all</a>
        </div>
        <div class="dropdown-col _TextFltr _TextSubPool" >
          <snl-dropdown [label]="'Pool'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
            [options]="Lng.subpool" [preSelectedItems]="subPools" (selectedValues)="selectedValues($event,'subpool')"
            (resetDropdown)="resetDropdown($event,'subpool')" [multiple]="true"></snl-dropdown>
        </div>
        <div class="dropdown-col _TextFltr _TextShipOwner " >
          <snl-dropdown [label]="'Ship owner'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
            [options]="Lng.shipOwners" [preSelectedItems]="shipOwners"
            (selectedValues)="selectedValues($event,'shipOwners')" (resetDropdown)="resetDropdown($event,'shipOwners')"
            [multiple]="true"></snl-dropdown>
        </div>
        <div class="dropdown-col _TextFltr _TextShipClass" >
          <snl-dropdown [label]="'Ship class'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
            [options]="Lng.vslClass" [preSelectedItems]="vslClasses"
            (selectedValues)="selectedValues($event,'vslClass')" (resetDropdown)="resetDropdown($event,'vslClass')"
            [multiple]="true"></snl-dropdown>
        </div>
        <div class="dropdown-col _TextFltr _TextShip" >
          <snl-dropdown [label]="'Ship'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'" 
            [options]="Lng.ship"
            [preSelectedItems]="shipNames" (selectedValues)="selectedValues($event,'ship')"
            (resetDropdown)="resetDropdown($event,'ship')" [multiple]="true"></snl-dropdown>
        </div>
      </div>
      <div right-side >
        <div class="monthlyYearlylables">
          <snl-button-toggle (onChange)="getYtdMonthlyVal($event)" [labels]="['YTD','Monthly']" [alignment]="'horizontal'"
            [defaultActive]="defaultActive"></snl-button-toggle>
        </div>  
      </div>
    </snl-action-panel>
     <!-- <div class="Skelton-section" *ngIf="Lng.isSkelton">
      <div class="sektion-filter"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
    </div> -->   
  </div>

  <div class="lngbunkerPricesection" *ngIf="getLngDatalist?.length">
    <span class="section-title" (click)="viewBunkerPrice()">View average bunker prices as of {{monthToShow }} {{yearToShow}}</span>   
  </div> 

  <!-- <div class="first-box">
    <ul class="lng-info-list body-b1">
        <li>
            <span>Total LNG savings</span>
            <span> Previous year's recognised amounts ($)</span>
        </li>
    </ul>
    <ul class="lng-info-list body-b1">
        <li>
            <b><span class="lng-bold-text">{{toggleVal === 'YTD' ? lngSavingFormuladata?.lngSavingsYTD : lngSavingFormuladata?.lngSavingsMonthly}}</span></b>
            <b>
              <span class="lng-bold-text">
                {{toggleVal === 'YTD' ? lngSavingFormuladata?.prevYearReconLngSavingsAmtYTD : lngSavingFormuladata?.prevYearReconLngSavingsAmt}}
              </span>
            </b>
        </li>
    </ul>
  </div> -->
  <div class="first-box">
    <div class="body-b1 totalLng">
      <div class="d-flex">
        Total LNG savings
      </div>
      <span class="section-title lng-bold-text">{{toggleVal === 'YTD' ? (lngSavingFormuladata?.lngSavingsYTD | negativeToBracket) : (lngSavingFormuladata?.lngSavingsMonthly | negativeToBracket)}}</span>
    </div>
    <div class="body-b1 prevYearLng">
      <div class="d-flex">
        Previous year's recognised amounts ($)
      </div>
      <span class="section-title lng-bold-text"> {{toggleVal === 'YTD' ? (lngSavingFormuladata?.prevYearReconLngSavingsAmtYTD | negativeToBracket ): (lngSavingFormuladata?.prevYearReconLngSavingsAmt | negativeToBracket)}}</span>
    </div>
  </div>

  <div class="lngTable scroll thin-scroll-x">
    <snl-table [useTopScroll]="false" [disableVerticalScroll]="true" class="expandable-table">
      <snl-row class="headerRow"  [ngClass]="isScrolled ? 'scrolledDown' : ''">
        <snl-th class="lngHeaderCol shipOwnerName">Ship / Ship owner / Pool</snl-th>
        <snl-th class="lngHeaderCol opDays">Operating days</snl-th>
        <snl-th class="lngHeaderCol scrubberSavings">
          <div>
            LNG savings ($) <br/>
            <snl-tooltip position="bottom" [config]="config" class="f-right">
              <span>
                <figure>
                  <img src="assets/img/Info.svg" alt="img">
                </figure>
            </span>
              <div tooltipContent class="tooltip-padding">
                <div class="body-b">
                  <app-static-data [lngSavings]="true" [forTooltip]="true"></app-static-data>
                </div>
              </div>
            </snl-tooltip>
          </div>
        </snl-th>
      </snl-row>
      <snl-row class="distance-row" *ngFor="let lngItems of getLngDatalist">
        <snl-td class="shipNameOWner">
          <span class="shipName section-title scrubber-shipname" >{{lngItems?.vslName}}</span><br>
          <span class="shipOwner body-b3">{{ownersLabel[lngItems?.vslOwner]}}/</span>
          <span class="shipSubpool body-b3">{{lngItems?.subPool}}</span>
        </snl-td>
        <snl-td class="opDays">
           <ng-container *ngIf="toggleVal === 'Monthly'">
             <!-- <span>{{lngItems?.opDays}}</span> -->
              <span [ngClass]="lngItems?.lngOffhireCurrentMonth ? 'addErrorcolor' : ''">
              <figure>
                <img *ngIf="lngItems?.lngOffhireCurrentMonth" src="assets/img/Warning.svg" alt="img">
                  <span class="body-b1" *ngIf="lngItems?.lngOffhireCurrentMonth" (click)="offHire = true;getOffHireLngData(lngItems);triggerGTMEvent(GoogleAnalyticsEvents.OPEN_OPERATING_DAYS_MODAL)">{{lngItems?.opDays | negativeToBracket}}</span>
                  <span class="body-b1" *ngIf="!lngItems?.lngOffhireCurrentMonth">{{lngItems?.opDays | negativeToBracket}}</span>
              </figure>
              </span>     
           </ng-container>
          <ng-container *ngIf="toggleVal === 'YTD'">
            <!-- <span (click)="getOffHireLngData(lngItems)">{{lngItems?.opDaysYTD}}</span> -->
            <span [ngClass]="[lngItems?.lngOffhireCurrentMonth ? 'addErrorcolor' : '',
             lngItems?.lngOffhirePreviousMonth ? 'addColor' : '']">
               <figure>
                <img *ngIf="lngItems?.lngOffhireCurrentMonth" src="assets/img/Warning.svg" alt="img">
                <span class="body-b1 s2"
                 *ngIf="lngItems?.lngOffhireCurrentMonth || lngItems?.lngOffhirePreviousMonth"
                 (click)="offHire = true;getOffHireLngData(lngItems);triggerGTMEvent(GoogleAnalyticsEvents.OPEN_OPERATING_DAYS_MODAL)">
                  {{lngItems?.opDaysYTD | negativeToBracket}}</span>
                <span class="body-b1 ss" 
                *ngIf="!lngItems?.lngOffhireCurrentMonth &&  !lngItems?.lngOffhirePreviousMonth">
                  {{lngItems?.opDaysYTD | negativeToBracket}}</span>
              </figure>    
             </span>   
          </ng-container>
        </snl-td>
        <snl-td class="scrubberSavings">
          {{(toggleVal === 'YTD' ? lngItems?.lngSavingsAmtYTD : lngItems?.lngSavingsAmt) | negativeToBracket}}
        </snl-td>
      </snl-row>
    </snl-table>
  </div>

  <div *ngIf="offHirelngData?.length"> 
  <snl-modal (click)="offHire = false" [type]="'large'" [open]="offHire">
    <div slot="heading" class="ppLargeModalHeading" *ngIf="offHirelngData?.length"> {{offHirelngShipName}} operating days - off hire details</div>
    <div slot="modalContent" class="modal-content">
      <app-dynamic-table *ngIf="offHirelngData?.length" [columnHeader]="columnHeader"
        [tableData]="offHirelngData" [offHireOpdays]="true"></app-dynamic-table>
    </div>
    <div slot="modalFooter">
      <snl-button size="large" (click)="offHire = false">Close</snl-button>
    </div>
  </snl-modal>
</div>


<snl-side-panel panelType="close" [headerName]="bunkerPriceHeaderName"  size="large" [(isOpen)]="isBunkerSectionOpen">
  <div sidePanelContent class="largeSidepanelWidth">
    <!-- <app-scrubber-calculation *ngIf="sidePanelScrubberData?.poolLevelScrubberSavings?.length" [calculationResponse]="getScrubberTotaldata"  [sidePanelScrubberData] = "sidePanelScrubberData" [toggleVal]="toggleVal" [viewDetailsSidePanel]="viewDetailsSidePanel"></app-scrubber-calculation> -->
    <snl-table *ngFor="let items of groupedByFiscalYear " class="lng-sidepanel-table">
      <snl-row class="lngmodal-thRowHeight">
        <snl-th >{{items[0]}}</snl-th>
        <snl-th class="lngcol">LNG cost ($)</snl-th>
        <snl-th class="lngcol">LSF cost ($)</snl-th>
        <snl-th class="lngcol">MGO cost ($)</snl-th>
      </snl-row>
      <snl-row *ngFor="let data of items[1]">
        <snl-td class="showMonth">
            <span class="section-title lng-text-color">{{data.month}}</span>
        </snl-td>
        <snl-td class="lngcol lng-text-color">
            {{data.LNGCost | negativeToBracket}}
        </snl-td>
        <snl-td class="lngcol lng-text-color">
            {{data.LSFCost | negativeToBracket}}
        </snl-td>
        <snl-td class="lngcol lng-text-color">
            {{data.MGOCost | negativeToBracket}}
        </snl-td>
      </snl-row>
    </snl-table>
  </div>
  <div sidePanelFooterContent>
      <snl-button type="primary" size="large" (click)="isBunkerSectionOpen = false">Close</snl-button>
  </div>
</snl-side-panel>
